import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const OLD_PASS = 'old pass'
export const PASSWORD = 'password'
export const NEW_PASS = 'new pass'
export const CONFIRM_PASS = 'confirm pass'
export const CHANGE = 'change'
export const REQUIRED_FIELDS = 'required fields'
export const ERROR_CONFIRM_PASSWORD = 'error confirm passwprd'

export default {
  [PORTUGUESE]: {
    [OLD_PASS]: 'Senha Antiga',
    [PASSWORD]: 'Senha',
    [NEW_PASS]: 'Nova Senha',
    [CONFIRM_PASS]: 'Confirme a Senha',
    [CHANGE]: 'Mudar',
    [REQUIRED_FIELDS]: 'Por favor preencha todos os campos obrigatórios',
    [ERROR_CONFIRM_PASSWORD]: 'A Senha e a Confirmação de Senha não são iguais.',
  },

  [ENGLISH]: {
    [OLD_PASS]: 'Old Password',
    [PASSWORD]: 'Password',
    [NEW_PASS]: 'New Password',
    [CONFIRM_PASS]: 'Confirm Password',
    [CHANGE]: 'Change',
    [REQUIRED_FIELDS]: 'Please fill in all the required fields',
    [ERROR_CONFIRM_PASSWORD]: 'The Password and the Confirm Password are not the same.',
  },

  [SPANISH]: {
    [OLD_PASS]: 'Contraseña Anterior',
    [PASSWORD]: 'La Contraseña',
    [NEW_PASS]: 'Nueva Contraseña',
    [CONFIRM_PASS]: 'Confirmar Contraseña',
    [CHANGE]: 'Cambiar',
    [REQUIRED_FIELDS]: 'Por favor, rellene todos los campos obligatorios',
    [ERROR_CONFIRM_PASSWORD]:
      'La contraseña y la contraseña de confirmación no son lo mismo.',
  },
}
